import { render, staticRenderFns } from "./ed-additional-sections.component.vue?vue&type=template&id=ecf1d822&scoped=true&"
import script from "./ed-additional-sections.component.ts?vue&type=script&lang=ts&"
export * from "./ed-additional-sections.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-additional-sections.component.scss?vue&type=style&index=0&id=ecf1d822&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecf1d822",
  null
  
)

export default component.exports